import { Component, Inject, Input } from "@angular/core";
import { Form, ConfFormValue, ConfFormControlValue, RequestViews, UIGroup, UIElement } from "../../../shared/models";
import { ConfiguratorStore, ConfPageSessionService } from "../../providers";
import { PanelComponent } from "../../shared/panelComponent";
import { PushMessageSelection } from "../../../shared/providers/pushMessage/pushMessageSelection";
import { CodeValueModelBuilder } from "../../../shared/components/code/providers/codeValueModelBuilder";
import * as Immutable from "immutable";
import { VisualObjectHelper } from "../../parameters/shared";

@Component({
  selector: 'form-panel',
  templateUrl: './formPanelComponent.html'
})
export class FormPanelComponent extends PanelComponent<Form> {

  public confFormValue: ConfFormValue;
  public uiElementId: number;

  @Input()
  public showTitle = true;

  public showEditorMargin = true;
  public showSummaryMargin = true;

  @Input()
  public view = RequestViews.Editor;

  constructor(
    public confStore: ConfiguratorStore,
    public confPageSessionService: ConfPageSessionService,
    @Inject(VisualObjectHelper) public visualObjectHelper: VisualObjectHelper,

    public builder: CodeValueModelBuilder,

  ) {
    super(confStore, confPageSessionService, visualObjectHelper);
  }

  ngOnInit() {

    this.confFormValue = this.confStore.getConfDataEntity<ConfFormValue>(this.configuration.longId, this.confSessionId, this.panel.longId);

    this.update();
    super.ngOnInit();
  }

  public listenChanges(): void {
    this.confStore.onConfigurationValueChange(this.configurationId, this.confSessionId, this.panel.longId, (value: ConfFormValue): void => {

      this.confFormValue = value;
      this.update();

    }).unsubscribeOn(this.unsubscribeSubject);
  }

  public update() {

    this.uiElementId = this.confFormValue.uiElements.first();

    this.showTitle = this.view != RequestViews.Summary && this.panel.title != null && this.panel.title.length > 0;
    this.showEditorMargin = this.view == RequestViews.Editor && this.panel.title != null && this.panel.title.length > 0;
    this.showSummaryMargin = this.view == RequestViews.Summary;
  }

  public onAction(event: PushMessageSelection) {

    let triggerElement: any = this.confStore.getElements(this.confSessionId).find((a) => a.id == event.key);

    this.confStore.setElementValue(event);

    if (triggerElement && triggerElement.className == "UIInput" && triggerElement.type == "submit") {
      let valuesById = this.confStore.getElementValuesById(this.confSessionId);

      let panelValueById = Immutable.Map<string, string>();

      let element = this.confStore.getElement(this.uiElementId, this.confSessionId);

      let elements = this.getAllElements(element);

      elements.forEach(element => {

        if (element.id && valuesById.has(element.id)) {
          panelValueById = panelValueById.set(element.id, valuesById.get(element.id));
        }

      });

      this.confStore.formControlSubmit(this.configurationId, this.confSessionId, this.panel.visualObjectId, +triggerElement.id, panelValueById, this.view);
    }

  }

  public getAllElements(rootElement: UIElement): UIElement[] {
    const allElements: UIElement[] = [];
    this.traverse(rootElement, allElements);
    return allElements;
  }

  public traverse(element: UIElement, allElements: UIElement[]) {
    allElements.push(element);

    if (element.className == "UIGroup") {
      let uiGroup = element as unknown as UIGroup;

      uiGroup.uiElements.forEach(a => {
        this.traverse(this.confStore.getElement(a, this.confSessionId), allElements);
      });

    }
  }
}